module.exports = __webpack_public_path__ + "img/logo-100.f06c048f.png";